/**
 * © 2025 Indikin.online. All rights reserved.
 * Made with ❤️ by YalaCoder.
 *
 * Guest User Context Definition
 *
 * - NEW FILE
 * - MISSION: To satisfy the `react-refresh/only-export-components` ESLint
 * rule by separating the context definition from its provider component.
 *
 * - FUNCTIONALITY: This file defines and exports the `GuestUserContext`. It
 * contains no React components, only the context object itself.
 */
import { createContext } from 'react';

// Defines the shape of the context for the guest user's email.
export const GuestUserContext = createContext({
  guestEmail: '',
  setGuestEmail: () => {},
});
